import { CONTAINER_ID_FOR_STANDALONE_MODE } from '../../e2e/utils/constants';

export const MountToContainer = () => (
  <div id={CONTAINER_ID_FOR_STANDALONE_MODE} className='h-full w-full flex-1 flex'>
    <div className='flex h-full w-full items-center justify-center'>
      <div className='text-center'>
        <div className='border-slate-200 border-t-slate-600 mb-4 inline-block h-12 w-12 animate-spin rounded-full border-4'></div>
        <div className='text-slate-600'>
          <p className='font-medium'>Standalone Aries will be mounted in this container...</p>
          <p className='mt-2 text-sm text-slate-500'>Please wait while the application loads</p>
        </div>
      </div>
    </div>
  </div>
);
